<script lang="ts">
  import type { RequestBuilder } from "@lernetz/request";
  import type { Writable } from "svelte/store";
  import Image from "./Image.svelte";

  export let request: RequestBuilder;
  export let preset: string;
  export let placeholder: string = preset;
  export let breakpoints: Record<number, string> = {};
  export let asset: Writable<{
    id: string;
    file: string;
    aspectRatio: number;
    width: number;
    height: number;
  }>;

  function mappedBreakpoints() {
    let mapped = {};
    Object.keys(breakpoints).forEach((key) => {
      mapped[key] = { preset: breakpoints[key] };
    });
    return mapped;
  }
</script>

{#key $asset?.id}
  <Image
    {request}
    width={$asset?.width}
    height={$asset?.height}
    vars={{ file: $asset?.file, preset }}
    placeholder={{ preset: placeholder }}
    breakpoints={mappedBreakpoints()}
    {...$$restProps}
  />
{/key}
